import { type ReactNode } from 'react';
import { Button } from '@/components/ui/button';
import type { PendingSanction } from '@/modules/payments';

const LABEL = 'text-[10px] uppercase tracking-wider text-text-tertiary';
const VALUE = 'text-sm text-text-primary';

function Field({
  label,
  children,
}: {
  label: string;
  children: ReactNode;
}): ReactNode {
  return (
    <div className="space-y-0.5">
      <p className={LABEL}>{label}</p>
      <div className={VALUE}>{children}</div>
    </div>
  );
}

export function SanctionBody({ s }: { s: PendingSanction }): ReactNode {
  return (
    <div className="space-y-md">
      <p className="text-xs text-text-secondary leading-relaxed">
        Un admin ha sancionado a un creador que añadiste. Esto descuenta
        creadores de tu pago de la semana.
      </p>
      <Field label="Creador">@{s.creator_username || '—'}</Field>
      <Field label="Motivo">{s.reason_label}</Field>
      <Field label="Penalización">
        <span className="font-mono tabular-nums text-error">
          -${s.eur_deducted.toFixed(2)}
        </span>{' '}
        <span className="text-text-tertiary">
          ({s.creators_deducted} creadores)
        </span>
      </Field>
      {s.notes ? <Field label="Notas del admin">{s.notes}</Field> : null}
    </div>
  );
}

export function SanctionFooter({
  index,
  total,
  pending,
  onAck,
}: {
  index: number;
  total: number;
  pending: boolean;
  onAck: () => void;
}): ReactNode {
  return (
    <div className="flex items-center justify-between border-t border-white/[0.06] pt-base">
      <span className="text-[10px] text-text-tertiary">
        {index + 1} de {total}
      </span>
      <Button variant="primary" size="sm" onClick={onAck} disabled={pending}>
        Entendido
      </Button>
    </div>
  );
}
